"use client"

import { useState, useEffect } from "react"
import { DashboardView } from "./DashboardView"
import { TaskListView } from "./TaskListView"
import { getReporteAvancePlanOperativo } from "../../services/reporteFAOPlanOperativo/reporteFAOPO"
import { processProjectData, calculateWeightedProgress } from "./data-processor"
import { Tabs as AntTabs, Spin, Alert } from "antd"
import { BarChartOutlined, UnorderedListOutlined } from "@ant-design/icons"

export function ProjectDashboard() {
  const [data, setData] = useState(null)
  const [weightedProgress, setWeightedProgress] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const [selectedProject, setSelectedProject] = useState(null)
  const [selectedPhase, setSelectedPhase] = useState(null)
  const [selectedTask, setSelectedTask] = useState(null)

  const [drillDownLevel, setDrillDownLevel] = useState("project")
  const [selectedProjectId, setSelectedProjectId] = useState(undefined)
  const [selectedActivityId, setSelectedActivityId] = useState(undefined)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rawData = await getReporteAvancePlanOperativo()
        const processed = processProjectData(rawData)
        const weighted = calculateWeightedProgress(rawData)

        setData(processed)
        setWeightedProgress(weighted)
      } catch (err) {
        console.error("❌ Error cargando datos:", err)
        setError("No se pudieron cargar los datos del reporte.")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleProjectClick = (projectId) => {
    setSelectedProjectId(projectId)
    setDrillDownLevel("activity")
    const project = weightedProgress.find((p) => p.oid === projectId)
    if (project) {
      setSelectedProject(`${project.codigo} - ${project.nombre}`)
    }
  }

  const handleActivityClick = (activityId) => {
    setSelectedActivityId(activityId)
    setDrillDownLevel("indicator")
    const project = weightedProgress.find((p) => p.oid === selectedProjectId)
    const activity = project?.actividades.find((a) => a.id === activityId)
    if (activity) {
      setSelectedPhase(`${activity.codigo} - ${activity.descripcion}`)
    }
  }

  const handleBack = () => {
    if (drillDownLevel === "indicator") {
      setDrillDownLevel("activity")
      setSelectedActivityId(undefined)
      setSelectedPhase(null)
    } else if (drillDownLevel === "activity") {
      setDrillDownLevel("project")
      setSelectedProjectId(undefined)
      setSelectedProject(null)
    }
  }

  if (loading)
    return (
      <div style={{ textAlign: "center", marginTop: "4rem" }}>
        <Spin size="large" tip="Cargando datos del reporte..." />
      </div>
    )

  if (error)
    return (
      <Alert
        message="Error al cargar datos"
        description={error}
        type="error"
        showIcon
        style={{ margin: "2rem" }}
      />
    )

  return (
    <div>
      <AntTabs
        defaultActiveKey="visualization"
        centered
        size="small"
        destroyOnHidden
        tabBarStyle={{
          background: "#042956",
          borderRadius: "8px",
          marginBottom: "24px",
          padding: "8px",
        }}
        items={[
          {
            key: "visualization",
            label: (
              <span style={{ fontWeight: 600, color: "#fff" }}>
                <BarChartOutlined style={{ color: "#fff" }} /> Visualización
              </span>
            ),
            children: (
              <div style={{ marginTop: "1.5rem" }}>
                <DashboardView
                  data={data}
                  weightedProgress={weightedProgress}
                  selectedProject={selectedProject}
                  selectedPhase={selectedPhase}
                  selectedTask={selectedTask}
                  drillDownLevel={drillDownLevel}
                  selectedProjectId={selectedProjectId}
                  selectedActivityId={selectedActivityId}
                  onProjectSelect={setSelectedProject}
                  onPhaseSelect={setSelectedPhase}
                  onTaskSelect={setSelectedTask}
                  onProjectClick={handleProjectClick}
                  onActivityClick={handleActivityClick}
                  onBack={handleBack}
                />
              </div>
            ),
          },
          {
            key: "tasks",
            label: (
              <span style={{ fontWeight: 600, color: "#fff" }}>
                <UnorderedListOutlined style={{ color: "#fff" }} /> Lista de Tareas
              </span>
            ),
            children: (
              <div style={{ marginTop: "1.5rem" }}>
                <TaskListView data={data} />
              </div>
            ),
          },
        ]}
      />
    </div>
  )
}
